import { render, staticRenderFns } from "./ActivityTransitionView.vue?vue&type=template&id=83ec1636&scoped=true&"
import script from "./ActivityTransitionView.vue?vue&type=script&lang=js&"
export * from "./ActivityTransitionView.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTransitionView.vue?vue&type=style&index=0&id=83ec1636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ec1636",
  null
  
)

/* custom blocks */
import block0 from "./ActivityTransitionView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports